import React from 'react'
import { REPORT_KEYS } from 'constants/reporting'
import ConsoleEmbed from 'components/ConsoleEmbed'

interface IInsuranceHeartbeatProps {
  print?: boolean
  useCarrierFilters: boolean
}

const InsuranceHeartbeatReport: React.FC<IInsuranceHeartbeatProps> = () => {
  return <ConsoleEmbed reportKey={REPORT_KEYS.PORTFOLIO_HEARTBEAT} fullHeight />
}
export default InsuranceHeartbeatReport
